import {useEffect} from 'react';

import {DayType} from '@optimaxdev/utils';
import {useQuery} from '@tanstack/react-query';

import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig} from 'libs/api/api';
import {logWithSentry} from 'libs/sentry/sentry';

export type IsCartEligibleForNextDayShippingType = {
    isCartEligibleForNextDayShipping: boolean;
    additionalData: {
        day: DayType;
        isAfterNoon: boolean;
    };
};

/**
 * react query hook for fetching eligible status for next day shipping
 */
export const useGetIsCartEligibleForNextDayShipping = () => {
    const result = useQuery({
        queryFn: async () => {
            const {data} =
                await apiConfig.instanceGusaBackend.request<IsCartEligibleForNextDayShippingType>({
                    method: 'get',
                    url: `${ENDPOINTS.CHECKOUT_GET_NEXT_DAY}`,
                });
            return data;
        },
        queryKey: ['cartShippingMethods'],
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (result.error) {
            logWithSentry(result.error, 'Cart Two Day Delivery: can`t get nextDayOption');
        }
    }, [result.error]);

    return result;
};
